module.exports = __webpack_public_path__ + "static/media/蜜蜂网.2d3b4ed7.png";